"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_1 = __importDefault(require("lodash/get"));
const react_1 = require("react");
const PreferencesContext_1 = require("../context/PreferencesContext");
const useActiveSpectra_1 = require("./useActiveSpectra");
function useActiveSpectrumStyleOptions(id) {
    const activeSpectra = (0, useActiveSpectra_1.useActiveSpectra)();
    const preferences = (0, PreferencesContext_1.usePreferences)();
    return (0, react_1.useMemo)(() => {
        const index = activeSpectra?.findIndex((activeSpectrum) => activeSpectrum.id === id);
        const isActive = !!(activeSpectra?.length === 0 || index !== -1);
        const opacity = isActive
            ? 1
            : (0, get_1.default)(preferences.current, 'general.dimmedSpectraOpacity', 0.1);
        return { isActive, opacity };
    }, [activeSpectra, id, preferences]);
}
exports.default = useActiveSpectrumStyleOptions;
